import React from 'react';

import { EditorHeaderProvider } from './context';
import HeaderLeft from './components/header-left';
import HeaderRight from './components/header-right';
import MenuWrapper from './components/menu-wrapper';
import Divider from './components/divider';
import Menu from './components/menu';
import Logo from './components/logo';
import LocalesSelectorWrapper from './components/locales-selector-wrapper';
import Nav from './components/nav';
import NavItem from './components/nav-item';
import PagesNavItem from './components/pages-nav-item';
import Controls from './components/controls';
import UndoButton from './components/undo-button';
import RedoButton from './components/redo-button';
import SaveButton from './components/save-button';
import Actions from './components/actions';
import PreviewButton from './components/preview-button';
import BuyDomainButton from './components/buy-domain-button';
import UpgradeButton from './components/upgrade-button';
import PublishButton from './components/publish-button';

function getHeight() {
  return parseFloat(
    getComputedStyle(document.body).getPropertyValue('--ws-ui-editor-header-height')
  );
}

const EditorHeader = ({ children }) => (
  <EditorHeaderProvider>
    <header className="ws-ui-editor-header">{children}</header>
  </EditorHeaderProvider>
);

EditorHeader.HeaderLeft = HeaderLeft;
EditorHeader.HeaderRight = HeaderRight;
EditorHeader.MenuWrapper = MenuWrapper;
EditorHeader.Menu = Menu;
EditorHeader.Logo = Logo;
EditorHeader.LocalesSelectorWrapper = LocalesSelectorWrapper;
EditorHeader.Nav = Nav;
EditorHeader.NavItem = NavItem;
EditorHeader.PagesNavItem = PagesNavItem;
EditorHeader.Controls = Controls;
EditorHeader.UndoButton = UndoButton;
EditorHeader.RedoButton = RedoButton;
EditorHeader.SaveButton = SaveButton;
EditorHeader.Actions = Actions;
EditorHeader.PreviewButton = PreviewButton;
EditorHeader.BuyDomainButton = BuyDomainButton;
EditorHeader.UpgradeButton = UpgradeButton;
EditorHeader.PublishButton = PublishButton;
EditorHeader.getHeight = getHeight;
EditorHeader.Divider = Divider;

export default EditorHeader;
